import React from 'react';

import LabelValue from '../LabelValue';

export type ExtensionsText = {
  key: string;
  value: string;
};
const AddOnCardExtensions = ({ extensions }: { extensions?: ExtensionsText[] }) => (
  <>
    {extensions?.map((extension) => (
      <LabelValue key={extension.key} label={extension.key} value={extension.value} />
    ))}
  </>
);

export default AddOnCardExtensions;
